'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.setThemeWidget = function (mapThemeModel) {
	return mmWidgets(this).click(function () {
		mapThemeModel.setTheme(mmWidgets(this).attr('data-mm-set-theme'));
	});
};
